import { createReducer, on } from '@ngrx/store';

import {
  fetchAirGroupResultsAction,
  fetchAirResultsAction,
  clearFlightResultsAction,
  searchFlightsAction,
  clearSearchPayloadAction,
  fetchAirResultsBySectorAction,
  fetchSearchAndFiltersAction,
  fetchAirGroupResultsSuccessAction,
  fetchAirResultsSuccessAction,
  fetchAirResultsBySectorSuccessAction,
  fetchExchangeTokenAction
} from '@flight-results/store/actions/flights-results.actions';
import { NewAirSearchPayload } from '@flight-results/entities/request-search.payload';
import { exchangeSearchAction } from '@user-history/store/actions/user-history.actions';

export const initialState: NewAirSearchPayload = {} as NewAirSearchPayload;

export const searchPayloadReducer = createReducer(
  initialState,
  on(
    searchFlightsAction,
    exchangeSearchAction,
    clearSearchPayloadAction,
    () => initialState
  ),
  on(
    fetchAirGroupResultsAction,
    fetchAirResultsAction,
    fetchAirResultsBySectorAction,
    (state, { payload }) => payload
  ),
  on(
    fetchAirGroupResultsSuccessAction,
    fetchAirResultsSuccessAction,
    fetchAirResultsBySectorSuccessAction,
    (state, { flightResults }) => 
      ({...state, 
        Results: {
          ...state.Results, 
          SearchId: flightResults.SearchId.length ? flightResults.SearchId : state.Results.SearchId
        }
      })
  ),
  on(
    fetchSearchAndFiltersAction,
    fetchExchangeTokenAction,
    (state, { payload }) => payload
  ),
  on(clearFlightResultsAction, (state, { isMobile }) => {
    return {
      ...state,
      Results: {
        ...state.Results,
        ResultCountLowerBound: 0,
        ResultCountUpperBound: isMobile ? 60 : 20
      }
    };
  }),
);
